import React, { useCallback, useEffect } from 'react';
import { Button, Icon, Typography, ScreenContainer, ContentFrame, LayoutContent, LayoutControls, } from '@pinwheel/origami';
import { useSelector } from 'react-redux';
import { useOpts } from '../context';
import './Intro.scss';
import ModalHeader from '../components/ModalHeader';
import TermsOfService, { TermsOfServiceTextVariant } from '../TermsOfService';
import { postIntroState } from '../utils/navigation';
import IntroLogo from '../IntroLogo';
import useIntro from '../hooks/useIntro';
import useLinkNavigate from '../hooks/useLinkNavigate';
import { useAppDispatch, useAppSelector } from '../state';
import { selectFeatureFlags, selectLinkParams, selectLinkTokenPayload, } from '../state/slices/slice-link-params';
import { useGetLocalizedString } from '../hooks/useGetLocalizedString';
import { ScreenTitleHeader } from '../components/ScreenTitleHeader';
import { selectIncomeSources } from '../state/slices/slice-wizard';
import { checkHackyWorkspace } from '../utils/hacky-workspace-customizations';
import { CitizensIntroContent } from '../components/CitizensIntroContent';
import { acceptTerms } from '../state/slices/slice-link-api';
import useLinkSolution from '../hooks/useLinkSolution';
var IntroRowCopyWithHeaderAndBody = function (props) { return (React.createElement("li", { className: "introFeature" },
    React.createElement("div", { className: "introFeature__header" },
        React.createElement(Icon, { icon: props.icon, className: "introFeature__icon", size: props.iconSize, color: props.iconColor }),
        React.createElement(Typography, { variant: "header", as: "h3", color: props.textColor }, props.header)),
    React.createElement("div", { className: "introFeature__description" }, props.body.map(function (b, i) {
        return (React.createElement(Typography, { variant: "body", color: "default", key: i }, b));
    })))); };
var IntroRowCopyBodyOnly = function (props) { return (React.createElement("li", { className: "introFeature" },
    React.createElement("div", { className: "introFeature__header" },
        React.createElement(Icon, { icon: props.icon, className: "introFeature__icon", size: props.iconSize, color: props.iconColor }),
        props.body.map(function (b, i) {
            return (React.createElement(Typography, { variant: "body", color: "default", key: i }, b));
        })))); };
var IntroRowCopyBodyOnlyNoIcon = function (props) { return (React.createElement("li", { className: "introFeature" },
    React.createElement("div", { className: "introFeature__no_icon" }, props.body.map(function (b, i) {
        return (React.createElement(Typography, { variant: "body", color: "light", key: i }, b));
    })))); };
var IntroRowCopyHeaderOnly = function (props) { return (React.createElement("li", { className: "introFeature" },
    React.createElement("div", { className: "introFeature__header" },
        React.createElement(Icon, { icon: props.icon, className: "introFeature__icon", size: props.iconSize, color: props.iconColor }),
        React.createElement(Typography, { variant: "header", as: "h3", color: props.textColor }, props.header)))); };
export function IntroContent(_a) {
    var onContinue = _a.onContinue;
    var getLocalizedString = useGetLocalizedString();
    var _b = useOpts(), fireClientEvent = _b.fireClientEvent, linkTokenPayload = _b.linkTokenPayload;
    var isDoordash = checkHackyWorkspace('DoorDash', linkTokenPayload === null || linkTokenPayload === void 0 ? void 0 : linkTokenPayload.workspaceName);
    useEffect(function () {
        fireClientEvent('input_required');
    }, [fireClientEvent]);
    var _c = useIntro(), title = _c.title, headerTextColor = _c.headerTextColor, iconColor = _c.iconColor, rows = _c.rows, showLogo = _c.showLogo, includeAndMore = _c.includeAndMore;
    return (React.createElement(React.Fragment, null,
        React.createElement(LayoutContent, { className: "introContent" },
            React.createElement("div", null,
                showLogo && React.createElement(IntroLogo, null),
                React.createElement("div", { className: "introFeatures" },
                    React.createElement(ScreenTitleHeader, { sx: {
                            marginBottom: '24px',
                        }, variant: "marquee", "data-testid": "introTitle", as: "h2", color: headerTextColor }, title),
                    React.createElement("ul", { style: {
                            padding: 0,
                        } },
                        rows.map(function (_a, i) {
                            var icon = _a.icon, iconSize = _a.iconSize, header = _a.header, body = _a.body;
                            if (!header && body) {
                                return (React.createElement(IntroRowCopyBodyOnly, { key: i, body: body, iconColor: iconColor, icon: icon, iconSize: iconSize, textColor: headerTextColor }));
                            }
                            if (!body && header) {
                                return (React.createElement(IntroRowCopyHeaderOnly, { key: i, header: header, iconColor: iconColor, icon: icon, iconSize: iconSize, textColor: headerTextColor }));
                            }
                            return (React.createElement(IntroRowCopyWithHeaderAndBody, { key: i, header: header, body: body, iconColor: iconColor, icon: icon, iconSize: iconSize, textColor: headerTextColor }));
                        }),
                        includeAndMore && (React.createElement(IntroRowCopyBodyOnlyNoIcon, { body: ['and more...'] })))))),
        React.createElement(LayoutControls, null,
            React.createElement(TermsOfService, { textVariant: isDoordash
                    ? TermsOfServiceTextVariant.CONTINUE_BUTTON
                    : TermsOfServiceTextVariant.GET_STARTED_BUTTON }),
            React.createElement(Button, { dataTestId: "button", "aria-label": "Continue", eventId: "IntroScreen-continue", onClick: onContinue }, getLocalizedString(isDoordash ? 'CONTINUE' : 'GET_STARTED')))));
}
var SwitchKitIntroContent = function (_a) {
    var onContinue = _a.onContinue;
    var getLocalizedString = useGetLocalizedString();
    var linkTokenPayload = useAppSelector(selectLinkTokenPayload);
    var rows = [
        {
            icon: 'shieldCheck',
            iconSize: 16,
            header: getLocalizedString('ENCRYPTED_AND_SECURE'),
            body: [getLocalizedString('SWITCH_KIT_INTRO_ROW_1')],
        },
        {
            icon: 'flash',
            iconSize: 16,
            header: getLocalizedString('CONVENIENT_AND_FAST'),
            body: [
                getLocalizedString('SWITCH_KIT_INTRO_ROW_2', [
                    (linkTokenPayload === null || linkTokenPayload === void 0 ? void 0 : linkTokenPayload.orgName) || 'Your Bank',
                ]),
            ],
        },
    ];
    return (React.createElement(React.Fragment, null,
        React.createElement(LayoutContent, null,
            React.createElement(IntroLogo, null),
            React.createElement(ScreenTitleHeader, { variant: "marquee", as: "h2", color: "default" }, getLocalizedString('SWITCH_KIT_INTRO_TITLE', [
                (linkTokenPayload === null || linkTokenPayload === void 0 ? void 0 : linkTokenPayload.orgName) || 'Your Bank',
            ])),
            React.createElement("ul", { style: {
                    padding: 0,
                } }, rows.map(function (_a, i) {
                var icon = _a.icon, iconSize = _a.iconSize, header = _a.header, body = _a.body;
                return (React.createElement(IntroRowCopyWithHeaderAndBody, { key: i, header: header, body: body, iconColor: {
                        type: 'theme',
                        colorLegacy: 'Primary/50',
                        colorNext: 'brand/default',
                    }, icon: icon, iconSize: iconSize }));
            }))),
        React.createElement(LayoutControls, null,
            React.createElement(TermsOfService, { textVariant: TermsOfServiceTextVariant.CONTINUE_BUTTON }),
            React.createElement(Button, { dataTestId: "button", "aria-label": "Continue", eventId: "IntroScreen-continue", onClick: onContinue }, getLocalizedString('CONTINUE')))));
};
var Intro = function () {
    var navigate = useLinkNavigate();
    var linkSolution = useLinkSolution().linkSolution;
    var _a = useOpts(), linkToken = _a.linkToken, modalSessionId = _a.modalSessionId, uniqueUserId = _a.uniqueUserId, fireTrackEvent = _a.fireTrackEvent;
    var linkTokenPayload = useSelector(selectLinkTokenPayload);
    var featureFlags = useAppSelector(selectFeatureFlags);
    var firstWizardScreen = useAppSelector(selectIncomeSources);
    var dispatch = useAppDispatch();
    var linkParams = useAppSelector(selectLinkParams);
    var onContinue = useCallback(function () {
        if (linkTokenPayload.enableBillNavigator) {
            void dispatch(acceptTerms({
                linkToken: linkToken,
                modalSessionId: modalSessionId || '',
                uniqueUserId: uniqueUserId,
                sdk: linkParams.sdk || '',
                sdkVersion: "".concat(linkParams.version.major, ".").concat(linkParams.version.minor, ".").concat(linkParams.version.patch),
            }));
        }
        fireTrackEvent('Link Intro Continue');
        navigate(postIntroState(linkTokenPayload, featureFlags, firstWizardScreen.visited));
    }, [
        featureFlags,
        fireTrackEvent,
        linkTokenPayload,
        firstWizardScreen,
        navigate,
        dispatch,
        linkParams,
        linkToken,
        modalSessionId,
        uniqueUserId,
    ]);
    var workspaceName = linkTokenPayload.workspaceName;
    // Citizens has a custom intro screen which deviates from the styling of our
    // default screen as well as their custom theme:
    // https://pinwheel.atlassian.net/browse/CORE-1663
    var isCitizens = checkHackyWorkspace('Citizens', workspaceName) ||
        checkHackyWorkspace('Citizens Theme Testing', workspaceName);
    return (React.createElement(ScreenContainer, { "data-testid": "intro" },
        React.createElement(ModalHeader, { onInfo: function () { return navigate('/info'); } }),
        React.createElement(ContentFrame, null, linkSolution && linkSolution === 'Switch Kit' ? (React.createElement(SwitchKitIntroContent, { onContinue: onContinue })) : isCitizens ? (React.createElement(CitizensIntroContent, { onContinue: onContinue })) : (React.createElement(IntroContent, { onContinue: onContinue })))));
};
export default Intro;
